// Artemis credits as tokens (WEB-7135): customers see roughly how many input and output tokens a pack
// or a balance buys, never its dollar value, which would show the margin over the pack's price.
// The rate is the user's own mix this month (tokens per dollar of usage) once there's enough of it
// to mean something; before that, a typical mix (the Usage guide's sample: 1,630,220 in and 52,310 out
// for $3.4125).

export const TYPICAL_RATES = { inPerUsd: 1630220 / 3.4125, outPerUsd: 52310 / 3.4125 }
// Below this much use this month, the user's own mix is too noisy to go by.
const MIN_USD_FOR_OWN_RATE = 0.5

// { inPerUsd, outPerUsd, own } from GET v3/Usage.
export const tokenRates = usage => {
  const used = Number(usage && usage.UsedUsd)
  const input = Number(usage && usage.InputTokens)
  const output = Number(usage && usage.OutputTokens)
  if (used >= MIN_USD_FOR_OWN_RATE && input > 0 && output > 0) return { inPerUsd: input / used, outPerUsd: output / used, own: true }
  return { ...TYPICAL_RATES, own: false }
}

// "2.4M", "77K", "900": rounded for an estimate.
export const formatTokens = n => {
  if (!Number.isFinite(n) || n <= 0) return '0'
  if (n >= 1e6) return `${(n / 1e6).toFixed(n >= 1e7 ? 0 : 1).replace(/\.0$/, '')}M`
  if (n >= 1e3) return `${Math.round(n / 1e3)}K`
  return String(Math.round(n / 10) * 10)
}

// "about 2.4M input and 77K output tokens" for an amount of Artemis usage in dollars.
export const tokensLabel = (usd, rates = TYPICAL_RATES) =>
  `about ${formatTokens(usd * rates.inPerUsd)} input and ${formatTokens(usd * rates.outPerUsd)} output tokens`
